// Minimal dangling-edge cleaner
// - Works with canvas edges (source/target)
// - Can also accept flow-like edges (from/to) if needed

export function cleanDanglingEdges(nodes = [], edges = []) {
  const nodeIds = new Set((nodes || []).map(n => String(n.id)));
  const validSources = new Set(nodeIds);
  const validTargets = new Set(nodeIds);
  validSources.add('START');
  validTargets.add('END');

  const removed = [];
  const edgesClean = [];

  for (const e of edges || []) {
    if (!e) continue;
    // Support both canvas and flow formats
    const s = (e.source !== undefined) ? String(e.source) : String(e.from || '');
    const t = (e.target !== undefined) ? String(e.target) : String(e.to || '');
    if (!s || !t || !validSources.has(s) || !validTargets.has(t)) {
      removed.push({ from: s, to: t });
      continue;
    }
    edgesClean.push(e);
  }

  return { edgesClean, removed };
}


